import React from 'react';
import PropTypes from 'prop-types';
import { cloneDeep, sortBy } from 'lodash';
import { createStructuredSelector } from 'reselect';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { TitleFrom, DataTable, GenericInput } from '../../../../components/common';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import { createRevenueMilestone } from '../../actions';
import { getIndexData } from '../../../../utils/utils';
import { listMilestoneFields } from '../../constants';
import { makeGetRevenueMilestoneItem } from '../../selectors';
import { MilestoneFormItem } from '../../../../components/RevenueHub';
import {
  getUniqueProductFamily,
  getUniqueProductLine,
  getUniqueProductSubType,
  getUniqueProductType,
} from '../../../App/actions';

class Milestone extends React.PureComponent {
  state = {
    data: { milestones: [] },
    isLoading: false,
    itemConfig: {},
    isModify: true,
    isSubmitting: false,
    wasValidated: false,
    formValid: true,
    productFamilyConfig: [],
    productLineConfig: [],
    productSubTypeConfig: [],
    productTypeConfig: [],
  };

  formRef = React.createRef();

  componentDidMount() {
    this.doGetListProductConfig();
  }

  doGetListProductConfig = () => {
    const { getUniqueProductFamily, getUniqueProductLine, getUniqueProductSubType, getUniqueProductType } = this.props;
    this.setState({ productFamily: '', productType: '', productSubType: '', productLine: '' });
    getUniqueProductFamily('', ({ data, success }) => {
      if (success)
        this.setState({
          productFamilyConfig:
            data && data.length
              ? sortBy(
                  data.map(val => ({ label: val.productFamily, value: val.productFamily })),
                  ['label']
                )
              : [],
        });
    });
    getUniqueProductLine('', ({ data, success }) => {
      if (success)
        this.setState({
          productLineConfig:
            data && data.length
              ? sortBy(
                  data.map(val => ({ label: val.productLine, value: val.productLine })),
                  ['label']
                )
              : [],
        });
    });
    getUniqueProductSubType('', ({ data, success }) => {
      if (success)
        this.setState({
          productSubTypeConfig:
            data && data.length
              ? sortBy(
                  data.map(val => ({ label: val.productSubType, value: val.productSubType })),
                  ['label']
                )
              : [],
        });
    });
    getUniqueProductType('', ({ data, success }) => {
      if (success)
        this.setState({
          productTypeConfig:
            data && data.length
              ? sortBy(
                  data.map(val => ({ label: val.productType, value: val.productType })),
                  ['label']
                )
              : [],
        });
    });
  };

  validate = (out = false) => {
    const { t } = this.props;
    const formValid = this.formRef && this.formRef.current.checkValidity();
    this.setState({ formValid });
    const { elements } = this.formRef.current;
    // console.log('validate')
    for (let i = 0; i < elements.length; i++) {
      if (!elements[i].validity.valid) {
        console.log(elements[i].name, 'invalid');
      }
    }
    if (!formValid && out) {
      toast.error(t('message.mandatory'));
    }
    return formValid;
  };

  onChange = ({ name, value }) => {
    const { data } = this.state;
    const newData = cloneDeep(data);
    newData[name] = value;
    this.setState({ data: newData });
  };

  onChangeTable = ({ name, value, index }) => {
    try {
      const { data } = this.state;
      const newData = cloneDeep(data);
      let newValue = value;
      if (value === 'TRUE') newValue = 'true';
      if (value === 'FALSE') newValue = 'false';
      newData.milestones[getIndexData({ index, data: newData.milestones })][name] = newValue;
      this.setState({ data: newData });
    } catch (error) {
      console.log(error);
    }
  };

  addNewItem = () => {
    try {
      const { data } = this.state;
      const newData = cloneDeep(data);
      let lastIndex = 0;
      newData.milestones.forEach(val => {
        if (val.index > lastIndex) lastIndex = val.index;
      });
      newData.milestones.push({
        index: lastIndex + 1,
        percent: 0,
        manual: 'false',
        frequency: 0,
      });
      this.setState({ data: newData });
    } catch (error) {
      console.log(error);
    }
  };

  onRemoveItem = ({ index }) => {
    const { data } = this.state;
    const newData = cloneDeep(data);
    newData.milestones.splice(getIndexData({ index, data: newData.milestones }), 1);
    this.setState({ data: newData });
  };

  handleSubmit = e => {
    e.preventDefault();
    this.setState({ wasValidated: true });
    const { createRevenueMilestone } = this.props;
    const { data } = this.state;
    if (!this.validate(true)) {
      return false;
    }
    return createRevenueMilestone({ ...data });
  };

  onCancel = () => {
    this.setState({ data: { milestones: [] } });
  };

  render() {
    const { t, permissions, location } = this.props;
    const { modeCreateMilestoneConfig } = permissions;
    if (modeCreateMilestoneConfig !== 2) return '';
    const {
      data,
      isLoading,
      wasValidated,
      productFamilyConfig,
      productLineConfig,
      productSubTypeConfig,
      productTypeConfig,
    } = this.state;
    const newListFields = cloneDeep(listMilestoneFields);
    if (productFamilyConfig && productFamilyConfig.length) {
      newListFields[2].options = productFamilyConfig;
    }

    if (productLineConfig && productLineConfig.length) {
      newListFields[3].options = productLineConfig;
    }

    if (productSubTypeConfig && productSubTypeConfig.length) {
      newListFields[4].options = productSubTypeConfig;
    }

    if (productTypeConfig && productTypeConfig.length) {
      newListFields[5].options = productTypeConfig;
    }

    const tableColumns = [
      {
        name: 'percent',
        label: 'label.percentage',
        render: (name, item) => {
          return (
            <GenericInput
              value={item.percent}
              name="percent"
              onChange={({ name, value }) => this.onChangeTable({ index: item.index, name, value })}
              wrapperClass="col-md-12"
            />
          );
        },
      },
      {
        name: 'manual',
        label: 'label.manualFlag',
        render: (name, item) => {
          return (
            <GenericInput
              value={item.manual === 'true' || item.manual === true ? 'TRUE' : 'FALSE'}
              name="manual"
              type="select"
              tOptions="selections:selectBool"
              onChange={({ name, value }) => this.onChangeTable({ index: item.index, name, value })}
              wrapperClass="col-md-12"
              menuPortalTarget
            />
          );
        },
      },
      {
        name: 'frequency',
        label: 'label.frequency',
        render: (name, item) => {
          return (
            <GenericInput
              value={item.frequency}
              name="frequency"
              type="number"
              onChange={({ name, value }) => this.onChangeTable({ index: item.index, name, value })}
              wrapperClass="col-md-12"
            />
          );
        },
      },
      {
        name: 'remove',
        label: 'label.remove',
        render: (colName, item) => {
          return (
            <div className="form-group col-md-12">
              <button type="button" className="btn-phone" onClick={() => this.onRemoveItem({ index: item.index })}>
                <i className="fa fa-trash" />
              </button>
            </div>
          );
        },
      },
    ];

    return (
      <div>
        <PageTitle
          linkTo={{
            pathname: RouteNames.revenueConfigurationMilestone.path,
            state: location && location.state ? location.state : null,
          }}
          titleBtn={t('label.back')}
          titleRight={t('label.newMilestoneConfiguration')}
        />
        <br />
        <form
          onSubmit={this.handleSubmit}
          className={`needs-validation col-sm-12 mb-30 card card-statistics ${wasValidated ? 'was-validated' : ''}`}
          noValidate
          ref={this.formRef}
        >
          <TitleFrom title={t('label.newMilestoneConfiguration')} />
          {/* <AccountHeaderFrom title={t('label.id')} accountNum="123123" /> */}
          <MilestoneFormItem listFields={newListFields} data={data} onChange={this.onChange} />
          <DataTable
            columns={tableColumns}
            data={data && data.milestones ? data.milestones : []}
            isLoading={isLoading}
          />
          <div className="form-group col-md-12 buttons-attibute">
            {modeCreateMilestoneConfig === 2 && (
              <button type="button" className="button button-border black x-small" onClick={this.addNewItem}>
                +
                {t('label.addNewMilestone')}
              </button>
            )}
            {modeCreateMilestoneConfig === 2 && (
              <button type="submit" className="button button-border x-small float-right">
                {t('label.create')}
              </button>
            )}
            <button onClick={this.onCancel} type="button" className="button button-border black x-small float-right">
              {t('label.cancel')}
            </button>
          </div>
        </form>
      </div>
    );
  }
}

Milestone.propTypes = {
  createRevenueMilestone: PropTypes.func,
  match: PropTypes.objectOf(PropTypes.any),
};

Milestone.defaultProps = {
  createRevenueMilestone: () => {},
  match: {},
};

const mapStateToProps = createStructuredSelector({
  revenueMilestoneItem: makeGetRevenueMilestoneItem() || {},
});

export default withTranslation('common')(
  connect(mapStateToProps, {
    createRevenueMilestone,
    getUniqueProductFamily,
    getUniqueProductLine,
    getUniqueProductSubType,
    getUniqueProductType,
  })(withRouter(Milestone))
);
